import FormItem from "@/module/FormItem";

export default class FormItemGroup {
  readonly title: string;
  public items: FormItem[];
  readonly id: number;
  readonly required: boolean;
  readonly allowMultipleItems: boolean;

  constructor(
    id: number,
    title: string,
    items: FormItem[],
    required: boolean,
    allowMultipleItems: boolean,
  ) {
    this.id = id;
    this.title = title;
    this.items = items;
    this.required = required;
    this.allowMultipleItems = allowMultipleItems;
  }
}
